"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeometryParser = void 0;
const math_1 = require("pixi.js/lib/core/math");
const ltpoint_1 = require("../cadplugins/cad/ltpoint");
const boundingBox_1 = require("./boundingBox");
const LineSegment_js_1 = __importDefault(require("jsts/org/locationtech/jts/geom/LineSegment.js"));
const Coordinate_js_1 = __importDefault(require("jsts/org/locationtech/jts/geom/Coordinate.js"));
const Vector2D_js_1 = __importDefault(require("jsts/org/locationtech/jts/math/Vector2D.js"));
const Polygonizer_js_1 = __importDefault(require("jsts/org/locationtech/jts/operation/polygonize/Polygonizer.js"));
const GeometryFactory_js_1 = __importDefault(require("jsts/org/locationtech/jts/geom/GeometryFactory.js"));
const util_1 = require("./polygon/util");
var PIXI = window.PIXI;
const angleTolerance = 5 * Math.PI / 180;
class GeometryParser {
    constructor() {
        this._blockMap = new Map();
        this._isColumnMap = new Map(); //记录块是否为柱子的表
        this._doors = new Array();
        this._columns = new Array();
    }
    ;
    //LTPolyline类型
    getLTPolyline(ltPolyline) {
        let points = new Array();
        for (let point of ltPolyline.subData().getEndPoints()) {
            points.push(point.clone());
        }
        return points;
    }
    //以前的矩形柱子无法包含多边形柱子的情况，以下为兼容多边形柱子的情况
    isColumn(blockVerticesArray) {
        if (this.isRectColumn(blockVerticesArray)) {
            return true;
        }
        return this.isPolygonColumn(blockVerticesArray);
    }
    //原来的矩形柱子判断方法
    isRectColumn(blockVerticesArray) {
        for (let blockVertices of blockVerticesArray) {
            //目前仅考虑矩形，算上首尾重复点，点数为5
            if (blockVertices.length != 5) {
                return false;
            }
            //遍历边，要求每个角度都为90°
            for (let i = 0; i < blockVertices.length - 2; i++) {
                let p1 = new Coordinate_js_1.default(blockVertices[i].x, blockVertices[i].y);
                let p2 = new Coordinate_js_1.default(blockVertices[i + 1].x, blockVertices[i + 1].y);
                let p3 = new Coordinate_js_1.default(blockVertices[i + 2].x, blockVertices[i + 2].y);
                let v1 = new Vector2D_js_1.default(p2, p1);
                let v2 = new Vector2D_js_1.default(p2, p3);
                let angle = v1.angleTo(v2); //范围为-PI~PI
                if (Math.abs(Math.abs(angle) - Math.PI / 2) > angleTolerance) {
                    return false;
                }
            }
        }
        return true;
    }
    isPolygonColumn(blockVerticesArray) {
        if (blockVerticesArray.length == 1) //只有一个多边形的直接返回true
            return true;
        if (blockVerticesArray.length > 2) //多于2个多边形直接不判断，返回false
            return false;
        let geometryFactory = new GeometryFactory_js_1.default();
        let polygons = new Array();
        for (let blockVertices of blockVerticesArray) {
            let points = new Array();
            for (let vertex of blockVertices) {
                points.push(new Coordinate_js_1.default(vertex.x, vertex.y));
            }
            if (points.length < 3)
                continue;
            //有些块不知道为什么没闭合，绘制出来看是闭合的，这里强行闭合一下
            if (!points[0].equals2D(points[points.length - 1])) {
                points.push(points[0]);
            }
            let polygon = geometryFactory.createPolygon(points);
            polygons.push(polygon);
        }
        if (polygons.length < 2)
            return false;
        polygons.sort(function (a, b) { return b.getArea() - a.getArea(); });
        if (util_1.Util.isPolygonContainsAnother(polygons[0], polygons[1])) {
            this.fixPolygonColumn(blockVerticesArray);
            return true;
        }
        else {
            return false;
        }
    }
    //有些特殊情况下柱子的点不闭合，这里强行闭合一下，不然缺少边
    fixPolygonColumn(blockVerticesArray) {
        for (let blockVertices of blockVerticesArray) {
            if (!blockVertices[0].equals(blockVertices[blockVertices.length - 1])) {
                blockVertices.push(blockVertices[0]);
            }
        }
    }
    getLTEntityPointV3(ltEntityPoint, map_isBlockClosed) {
        const point = ltEntityPoint.subData();
        const matrix = new math_1.Matrix();
        matrix.scale(point.scaleFactors.x, point.scaleFactors.y);
        matrix.rotate(point.getRotate());
        if (point.position != null) {
            matrix.translate(point.position.x, point.position.y);
        }
        let blockVerticesArray = new Array();
        for (let graphicsData of ltEntityPoint._graphicsData) {
            if (graphicsData.istext === true)
                continue;
            let pointValues = graphicsData.points;
            let vertices = new Array();
            for (let i = 0; i < pointValues.length; i += 2) {
                let vertex = new ltpoint_1.LTPoint(pointValues[i], pointValues[i + 1]);
                matrix.applyInverse(vertex, vertex);
                vertices.push(vertex);
            }
            blockVerticesArray.push(vertices);
        }
        if (blockVerticesArray.length === 0) { //"_GCBLK"块情况，原因不明
            return undefined;
        }
        let isColumn = this.isColumn(blockVerticesArray);
        //判断一下是否这些线段能否组成闭合区域
        if (!isColumn) {
            if (map_isBlockClosed.has(ltEntityPoint.subData().blockName) === false)
                map_isBlockClosed.set(ltEntityPoint.subData().blockName, this.isClosed(blockVerticesArray));
        }
        //简化门的顶点，变成一根线段
        if (!isColumn) {
            blockVerticesArray = this.simplifyDoorVerticesToLines(blockVerticesArray);
        }
        this._isColumnMap.set(ltEntityPoint.subData().blockName, isColumn);
        let verticesArray = new Array();
        for (let blockVertices of blockVerticesArray) {
            let vertices = new Array();
            for (let i = 0; i < blockVertices.length; i++) {
                let vertex = matrix.apply(blockVertices[i], new ltpoint_1.LTPoint(0, 0));
                vertices.push(vertex);
            }
            verticesArray.push(vertices);
        }
        if (!this._isColumnMap.get(ltEntityPoint.subData().blockName)) {
            for (let vertices of verticesArray) {
                this._doors.push(new LineSegment_js_1.default(new Coordinate_js_1.default(vertices[0].x, vertices[0].y), new Coordinate_js_1.default(vertices[1].x, vertices[1].y)));
            }
        }
        else {
            for (let vertices of verticesArray) {
                for (let i = 0; i < vertices.length - 1; i++) {
                    this._columns.push(new LineSegment_js_1.default(new Coordinate_js_1.default(vertices[i].x, vertices[i].y), new Coordinate_js_1.default(vertices[i + 1].x, vertices[i + 1].y)));
                }
            }
        }
        return verticesArray;
    }
    isClosed(blockVerticesArray) {
        const factory = new GeometryFactory_js_1.default();
        const polygonizer = new Polygonizer_js_1.default();
        for (let line of blockVerticesArray) {
            let arr = new Array();
            for (let point of line) {
                //不明原因的Nan值，需要过滤
                if (Number.isNaN(point.x) || Number.isNaN(point.y)) {
                    continue;
                }
                arr.push(new Coordinate_js_1.default(point.x, point.y));
            }
            let lineString = factory.createLineString(arr);
            polygonizer.add(lineString);
        }
        let result = polygonizer.getPolygons();
        return result.length > 0;
    }
    getBlockVertices(graphics) {
        let verticesArray = new Array();
        for (let graphic of graphics) {
            const datas = graphic.geometry.graphicsData;
            for (let data of datas) {
                if (!data.shape.points)
                    continue;
                let vertices = new Array();
                //两个值构成一个点
                for (let i = 0; i < data.shape.points.length; i += 2) {
                    vertices.push(new ltpoint_1.LTPoint(data.shape.points[i], data.shape.points[i + 1]));
                }
                verticesArray.push(vertices);
            }
        }
        return verticesArray;
    }
    getLTHatch(ltHatch) {
        let verticesArray = new Array();
        for (let rPolyline of ltHatch.subData()._outline) {
            //getEndPoints
            verticesArray.push(rPolyline.getEndPoints());
        }
        return verticesArray;
    }
    getLTLine(ltLine) {
        let points = new Array();
        for (let point of ltLine.subData().getEndPoints()) {
            points.push(point.clone());
        }
        return points;
    }
    getLTArc(ltArc) {
        const lengthStep = 50; //采样间隔为50
        return ltArc.subData().approximateWithLines(lengthStep).subData().getEndPoints();
    }
    //废弃方法？
    simplifyDoorVertices(verticesArray) {
        //单开门用比较简单的方式去处理
        if (verticesArray.length === 2) {
            let lineString1 = verticesArray[0];
            let lineString2 = verticesArray[1];
            let vertices = [lineString1[0], lineString1[lineString1.length - 1], lineString2[0], lineString2[lineString2.length - 1]];
            for (let i = 0; i < vertices.length; i++) {
                for (let j = 0; j < vertices.length; j++) {
                    if (i !== j && vertices[i].equalsFuzzy(vertices[j], 1e-4)) {
                        vertices.splice(Math.max(i, j), 1);
                        vertices.splice(Math.min(i, j), 1);
                        return [[vertices[0], vertices[1]]];
                    }
                }
            }
            console.error("单开门情况异常");
        }
        //窄长的方格子门也做特殊处理
        if (verticesArray.length === 4) {
            let isRectangleDoor = true;
            for (let vertices of verticesArray) {
                if (vertices.length !== 2) {
                    isRectangleDoor = false;
                    break;
                }
            }
            if (isRectangleDoor === true) {
                verticesArray.sort((a, b) => { return a[0].getDistanceTo(a[1]) - b[0].getDistanceTo(b[1]); });
                let shortSeg1 = verticesArray[0];
                let shortSeg2 = verticesArray[1];
                let center1 = shortSeg1[0].plus(shortSeg1[1]).dot(0.5);
                let center2 = shortSeg2[0].plus(shortSeg2[1]).dot(0.5);
                return [[center1, center2]];
            }
        }
        //点排重
        let points_noRepeat = new Array();
        for (let vertices of verticesArray) {
            for (let vertex of vertices) {
                let existed = false;
                for (let point of points_noRepeat) {
                    if (point.x === vertex.x && point.y === vertex.y) {
                        existed = true;
                        break;
                    }
                }
                if (existed === false) {
                    points_noRepeat.push(new Coordinate_js_1.default(vertex.x, vertex.y));
                }
            }
        }
        //通过包围盒构造矩形
        let boundingBox = new boundingBox_1.BoundingBox();
        for (let vertices of verticesArray) {
            for (let vertex of vertices) {
                boundingBox.expand(vertex);
            }
        }
        let lt = new Coordinate_js_1.default(boundingBox.min.x, boundingBox.max.y);
        let rt = new Coordinate_js_1.default(boundingBox.max.x, boundingBox.max.y);
        let rb = new Coordinate_js_1.default(boundingBox.max.x, boundingBox.min.y);
        let lb = new Coordinate_js_1.default(boundingBox.min.x, boundingBox.min.y);
        let lineSegments = [new LineSegment_js_1.default(lt, rt), new LineSegment_js_1.default(rt, rb), new LineSegment_js_1.default(rb, lb), new LineSegment_js_1.default(lb, lt)];
        //统计每个线段上的点数量
        let countArr = [0, 0, 0, 0];
        for (let i = 0; i < lineSegments.length; i++) {
            let lineSegment = lineSegments[i];
            for (let j = 0; j < points_noRepeat.length; j++) {
                let point = points_noRepeat[j];
                if (lineSegment.distance(point) === 0) {
                    countArr[i]++;
                }
            }
        }
        //从原数组中挑出只有两个顶点的部分，并移除矩形与原数组重合的线段
        let blockSegments = new Array();
        for (let vertices of verticesArray) {
            if (vertices.length === 2) {
                blockSegments.push(new LineSegment_js_1.default(vertices[0].x, vertices[0].y, vertices[1].x, vertices[1].y));
            }
        }
        if (blockSegments.length === 0) {
            console.error("未考虑的情况");
        }
        for (let i = lineSegments.length - 1; i >= 0; i--) {
            for (let blockSeg of blockSegments) {
                if (lineSegments[i].equalsTopo(blockSeg)) {
                    lineSegments.splice(i, 1);
                    countArr.splice(i, 1);
                    break;
                }
            }
        }
        //选长度最大的一边作为简化后的边
        let maxCount = Math.max(...countArr);
        let resultSeg = lineSegments[countArr.indexOf(maxCount)];
        return [[new ltpoint_1.LTPoint(resultSeg.p0.x, resultSeg.p0.y), new ltpoint_1.LTPoint(resultSeg.p1.x, resultSeg.p1.y)]];
    }
    //通过包围盒去判断
    simplifyDoorVerticesToLines(verticesArray) {
        //通过包围盒构造矩形
        let boundingBox = new boundingBox_1.BoundingBox();
        for (let vertices of verticesArray) {
            for (let vertex of vertices) {
                boundingBox.expand(vertex);
            }
        }
        let lt = new ltpoint_1.LTPoint(boundingBox.min.x, boundingBox.max.y);
        let rt = new ltpoint_1.LTPoint(boundingBox.max.x, boundingBox.max.y);
        let rb = new ltpoint_1.LTPoint(boundingBox.max.x, boundingBox.min.y);
        let lb = new ltpoint_1.LTPoint(boundingBox.min.x, boundingBox.min.y);
        return [[lt, rt], [rt, rb], [rb, lb], [lb, lt]];
    }
    getDoorLineSegments() {
        return this._doors;
    }
    getColumnLineSegments() {
        return this._columns;
    }
    getWaterFlowIndicatorRightMostPoint(ltEntityPoint, globalBlockMap) {
        const RPoint = ltEntityPoint.subData();
        const matrix = new math_1.Matrix();
        matrix.scale(RPoint.scaleFactors.x, RPoint.scaleFactors.y);
        matrix.rotate(RPoint.getRotate());
        if (RPoint.position != null) {
            matrix.translate(RPoint.position.x, RPoint.position.y);
        }
        let containers = globalBlockMap.get(ltEntityPoint.subData().blockName);
        let blockVerticesArray = this.getBlockVertices(containers);
        //取X值最大的点
        let minX_point = new ltpoint_1.LTPoint(Number.POSITIVE_INFINITY, 0);
        let maxX_point = new ltpoint_1.LTPoint(Number.NEGATIVE_INFINITY, 0);
        for (let blockVertices of blockVerticesArray) {
            for (let i = 0; i < blockVertices.length; i++) {
                let point = blockVertices[i];
                if (point.x > maxX_point.x) {
                    maxX_point = point;
                }
                if (point.x < minX_point.x) {
                    minX_point = point;
                }
            }
        }
        //应用上变换矩阵
        return [matrix.apply(minX_point, new ltpoint_1.LTPoint(0, 0)), matrix.apply(maxX_point, new ltpoint_1.LTPoint(0, 0))];
    }
}
exports.GeometryParser = GeometryParser;
